import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-with-no-auth',
  templateUrl: './with-no-auth.component.html',
  styleUrls: ['./with-no-auth.component.scss'],
})
export class WithNoAuthComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
